import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { TrackerService } from 'src/app/components/logging/tracker.service';

@Component({
  selector: 'upgrade-feature-modal',
  templateUrl: './upgrade-feature-modal.component.html',
  styleUrl: './upgrade-feature-modal.component.scss',
  standalone: false,
})
export class UpgradeFeatureModalComponent {
  cta = '';
  plan = '';
  title = '';
  description = '';
  imageSource = '';
  background = '';
  helpLink = '';
  bulletPoints: string[] = [];
  contactSalesLink = '';
  upgradeButtonText = '';

  constructor(
    public dialogRef: MatDialogRef<UpgradeFeatureModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UpgradeFeatureModalData,
    private trackerService: TrackerService,
    private userStateService: UserStateService,
  ) {
    this.cta = data.cta;
    this.plan = data.plan;
    this.title = data.title;
    this.description = data.description;
    this.imageSource = data.imageSource;
    this.background = data.background;
    this.helpLink = data.helpLink;
    this.bulletPoints = data.bulletPoints || [];
    this.contactSalesLink = data.contactSalesLink || '';
    this.upgradeButtonText = data.upgradeButtonText || '';
  }

  dismiss() {
    this.dialogRef.close(false);
  }

  upgrade() {
    this.dialogRef.close(true);
  }

  contactSales() {
    if (this.contactSalesLink) {
      this.trackerService.userEvent(
        'Contact Sales Upgrade Button Clicked',
        this.userStateService.getUsername(),
        true,
        { feature: this.title },
      );
      window.open(this.contactSalesLink, '_blank');
    }
    this.dialogRef.close(false);
  }
}

interface UpgradeFeatureModalData {
  cta: string;
  plan?: string;
  title: string;
  description: string;
  imageSource: string;
  background: string;
  helpLink: string;
  bulletPoints?: string[];
  contactSalesLink?: string;
  upgradeButtonText?: string;
}
